import React from 'react';
import PinDropIcon from '@material-ui/icons/PinDrop';
import RMSCommonDialog from 'features/shared/components/dialog/RMSCommonDialog';
import { CommonDataGrid } from 'features/shared/components/table';
import { useAddressDialog } from 'features/user/hooks/useAddressDialog';

import { ADDRESS_DUPLICATE_GRID_COLUMNS } from 'features/user/constants/addressDuplicateDialogConstants';

const AddressDuplicateDialog = ({ open, onClose, rows }) => {
  const { openAddressDialog } = useAddressDialog();
  return (
    <RMSCommonDialog
      open={open}
      title="Duplicate Address List"
      onClose={onClose}
      maxWidth="md"
      saveButton={{ show: false }}
      cancelButton={{ show: true, type: 'simple', label: 'Close' }}>
      <div className="address-duplicate-dialog__grid">
        <CommonDataGrid
          rows={rows}
          columns={ADDRESS_DUPLICATE_GRID_COLUMNS}
          getRowId={(row) => row.ptsAddressID}
          actions={{
            custom: [
              {
                icon: <PinDropIcon />,
                tooltip: 'View Duplicate Address',
                onClick: (row) => openAddressDialog(row.ptsAddressID),
              },
            ],
          }}
        />
      </div>
    </RMSCommonDialog>
  );
};
export default AddressDuplicateDialog;
